import React from 'react'
import utils from './utils'
import { images } from '../../../../services/assets.services'

function getLevelLayout(width, height, settings, quantities, answer) {
    return settings.operation === 'addition' ?
        getAdditionLayout(width, height, settings, quantities, answer) :
        getSubtractionLayout(width, height, settings, quantities, answer)
}

function getAdditionLayout(width, height, settings, quantities, answer) {
    let gameContainerWidth = width
    let gameContainerHeight = height
    let scale = 0
    let gridBgWidth = 377
    let gridBgHeight = 210
    let lineWidth = 377
    let lineHeight = 20
    let valueBgWidth = 43
    let valueBgHeight = 33
    let axisLineWidth = 12
    let axisLineHeight = 34
    let axisSideMargin = 12

    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }

    const value_1 = quantities.value_1
    const value_2 = quantities.value_2
    const operation = settings.operation

    const axisScale = +settings.axis_scale
    const showStep = settings.show_step

    let axisValues = []
    let curves = []

    const axisStart = settings.axis_start_value ? settings.axis_start_value : value_1
    const axisEnd = settings.axis_end_value ? settings.axis_end_value : value_1 + value_2
    const axisDivWidth = (gridBgWidth - axisSideMargin * 2 - axisLineWidth) / (axisEnd - axisStart)
    const stepSize = settings.step_size || 1

    let maxArcHeight = gridBgHeight

    for (let i = 0; i <= (axisEnd - axisStart); i += axisScale) {
        axisValues.push(

            <g transform={`translate(${axisSideMargin + i * axisDivWidth}, ${gridBgHeight - 20})`}>
                <image
                    width={axisLineWidth}
                    height={axisLineHeight}
                    xlinkHref={images.svg['number-line-axis']}

                />
                <text
                    fill="#fff"
                    fontSize={12}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={6}
                    y={axisLineHeight + 10}
                    textAnchor="middle"
                >{+axisStart + i}</text>
            </g>
        )
    }

    if (showStep) {
        let value = value_2
        let index = 0
        while (value >= stepSize) {
            let arcStart = axisSideMargin + axisLineWidth / 2 + (value_1 + index * stepSize - axisStart) * axisDivWidth
            let arcLength = (stepSize) * axisDivWidth
            let arcRadius = (arcLength) / 1.8
            let centerToChordLenght = Math.sqrt(Math.pow(arcRadius, 2) - Math.pow(arcLength / 2, 2))
            maxArcHeight = arcRadius - centerToChordLenght + 40
            curves.push(
                <g key={0}>
                    <path
                        d={`M${arcStart} 185 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#000"
                        strokeOpacity="0.1"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    <path
                        d={`M${arcStart} 180 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#95c11f"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />

                    {utils.getArrowLayout(arcStart + arcLength, 185, 40, 4.01490021, "#95c11f")}
                    <g transform={`translate(${arcStart + arcLength / 2 - valueBgWidth / 2}, ${180 + centerToChordLenght - arcRadius - valueBgHeight * 1.2})`}>
                        <image
                            width={valueBgWidth}
                            height={valueBgHeight}
                            xlinkHref={images.svg['number-line-bg-green']}

                        />
                        <text
                            fill="#fff"
                            fontSize={12}
                            fontWeight="regular"
                            dominantBaseline="middle"
                            x={valueBgWidth / 2}
                            y={15}
                            textAnchor="middle"
                        >{"+" + stepSize}</text>
                    </g>
                </g>
            )
            value -= stepSize
            index++
        }
        if (value > 0) {
            let arcStart = axisSideMargin + axisLineWidth / 2 + (value_1 + (index) * stepSize - axisStart) * axisDivWidth
            let arcLength = (value) * axisDivWidth
            let arcRadius = (arcLength) / 1.8
            let centerToChordLenght = Math.sqrt(Math.pow(arcRadius, 2) - Math.pow(arcLength / 2, 2))
            curves.push(
                <g key={0}>
                    <path
                        d={`M${arcStart} 185 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#000"
                        strokeOpacity="0.1"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    <path
                        d={`M${arcStart} 180 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#95c11f"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    {utils.getArrowLayout(arcStart + arcLength, 185, 40, 4.01490021, "#95c11f")}
                    <g transform={`translate(${arcStart + arcLength / 2 - valueBgWidth / 2}, ${180 + centerToChordLenght - arcRadius - valueBgHeight * 1.2})`}>
                        <image
                            width={valueBgWidth}
                            height={valueBgHeight}
                            xlinkHref={images.svg['number-line-bg-green']}

                        />
                        <text
                            fill="#fff"
                            fontSize={12}
                            fontWeight="regular"
                            dominantBaseline="middle"
                            x={valueBgWidth / 2}
                            y={15}
                            textAnchor="middle"
                        >{"+" + value}</text>
                    </g>
                </g>
            )
        }
    } else {
        let arcStart = axisSideMargin + axisLineWidth / 2 + (value_1 - axisStart) * axisDivWidth
        let arcLength = (value_2) * axisDivWidth
        let arcRadius = (arcLength) / 1.8
        let centerToChordLenght = Math.sqrt(Math.pow(arcRadius, 2) - Math.pow(arcLength / 2, 2))
        maxArcHeight = arcRadius - centerToChordLenght + 40
        curves.push(
            <g key={0}>
                <path
                    d={`M${arcStart} 185 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                    stroke="#000"
                    strokeOpacity="0.1"
                    strokeWidth="4.01490021"
                    fill="none"
                    strokeDasharray="6.0312, 8.0415"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                />
                <path
                    d={`M${arcStart} 180 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                    stroke="#95c11f"
                    strokeWidth="4.01490021"
                    fill="none"
                    strokeDasharray="6.0312, 8.0415"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                />
                {utils.getArrowLayout(arcStart + arcLength, 185, 40, 4.01490021, "#95c11f")}
                <g transform={`translate(${arcStart + arcLength / 2 - valueBgWidth / 2}, ${180 + centerToChordLenght - arcRadius - valueBgHeight * 1.2})`}>
                    <image
                        width={valueBgWidth}
                        height={valueBgHeight}
                        xlinkHref={images.svg['number-line-bg-green']}

                    />
                    <text
                        fill="#fff"
                        fontSize={12}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={valueBgWidth / 2}
                        y={15}
                        textAnchor="middle"
                    >{settings.answer_required === 'value_2' ? answer :  "+" + (value_2)}</text>
                </g>
            </g>
        )
    }

    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}

        >
            <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale - (gridBgHeight - maxArcHeight) * scale) / 2}), scale(${scale})`}>
                {axisValues}
                <image
                    width={lineWidth}
                    height={lineHeight}
                    xlinkHref={images.svg['number-line']}
                    transform={`translate(${0}, ${gridBgHeight - 13})`}

                />
                {curves}

            </g>
        </svg>
    )
}

function getSubtractionLayout(width, height, settings, quantities, answer) {
    let gameContainerWidth = width
    let gameContainerHeight = height
    let scale = 0
    let gridBgWidth = 377
    let gridBgHeight = 210
    let lineWidth = 377
    let lineHeight = 20
    let valueBgWidth = 43
    let valueBgHeight = 33
    let axisLineWidth = 12
    let axisLineHeight = 34
    let axisSideMargin = 12

    if (gridBgWidth / gridBgHeight > gameContainerWidth / gameContainerHeight) {
        scale = gameContainerWidth / gridBgWidth
    } else {
        scale = gameContainerHeight / gridBgHeight
    }

    const value_1 = quantities.value_1
    const value_2 = quantities.value_2
    const operation = settings.operation

    const axisScale = +settings.axis_scale
    const showStep = settings.show_step

    let axisValues = []
    let curves = []

    const axisStart = settings.axis_start_value ? settings.axis_start_value : value_1 - value_2
    const axisEnd = settings.axis_end_value ? settings.axis_end_value : value_1
    const axisDivWidth = (gridBgWidth - axisSideMargin * 2 - axisLineWidth) / (axisEnd - axisStart)
    const stepSize = settings.step_size || 1

    let maxArcHeight = gridBgHeight

    for (let i = 0; i <= (axisEnd - axisStart); i += axisScale) {
        axisValues.push(
            <g transform={`translate(${axisSideMargin + i * axisDivWidth}, ${gridBgHeight - 20})`}>
                <image
                    width={axisLineWidth}
                    height={axisLineHeight}
                    xlinkHref={images.svg['number-line-axis']}

                />
                <text
                    fill="#fff"
                    fontSize={12}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={6}
                    y={axisLineHeight + 10}
                    textAnchor="middle"
                >{+axisStart + i}</text>
            </g>
        )
    }

    if (showStep) {
        let value = value_2
        let index = 0
        while (value >= stepSize) {
            let arcStart = axisSideMargin + axisLineWidth / 2 + (value_1 - (index + 1) * stepSize - axisStart) * axisDivWidth
            let arcLength = (stepSize) * axisDivWidth
            let arcRadius = (arcLength) / 1.8
            let centerToChordLenght = Math.sqrt(Math.pow(arcRadius, 2) - Math.pow(arcLength / 2, 2))
            maxArcHeight = arcRadius - centerToChordLenght + 40
            curves.push(
                <g key={index}>
                    <path
                        d={`M${arcStart} 185 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#000"
                        strokeOpacity="0.1"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    <path
                        d={`M${arcStart} 180 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#E30613"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    {utils.getArrowLayout(arcStart, 185, 40, 4.01490021, "#E30613")}
                    <g transform={`translate(${arcStart + arcLength / 2 - valueBgWidth / 2}, ${180 + centerToChordLenght - arcRadius - valueBgHeight * 1.2})`}>
                        <image
                            width={valueBgWidth}
                            height={valueBgHeight}
                            xlinkHref={images.svg['number-line-bg-red']}

                        />
                        <text
                            fill="#fff"
                            fontSize={12}
                            fontWeight="regular"
                            dominantBaseline="middle"
                            x={valueBgWidth / 2}
                            y={15}
                            textAnchor="middle"
                        >{"-" + stepSize}</text>
                    </g>
                </g>
            )
            value -= stepSize
            index++
        }
        if (value > 0) {
            let arcStart = axisSideMargin + axisLineWidth / 2 + (value_1 - value - (index) * stepSize - axisStart) * axisDivWidth
            let arcLength = (value) * axisDivWidth
            let arcRadius = (arcLength) / 1.8
            let centerToChordLenght = Math.sqrt(Math.pow(arcRadius, 2) - Math.pow(arcLength / 2, 2))
            curves.push(
                <g key={index}>
                    <path
                        d={`M${arcStart} 185 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#000"
                        strokeOpacity="0.1"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    <path
                        d={`M${arcStart} 180 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                        stroke="#E30613"
                        strokeWidth="4.01490021"
                        fill="none"
                        strokeDasharray="6.0312, 8.0415"
                        strokeLinejoin="round"
                        strokeLinecap="round"
                    />
                    {utils.getArrowLayout(arcStart, 185, 40, 4.01490021, "#E30613")}
                    <g transform={`translate(${arcStart + arcLength / 2 - valueBgWidth / 2}, ${180 + centerToChordLenght - arcRadius - valueBgHeight * 1.2})`}>
                        <image
                            width={valueBgWidth}
                            height={valueBgHeight}
                            xlinkHref={images.svg['number-line-bg-red']}

                        />
                        <text
                            fill="#fff"
                            fontSize={12}
                            fontWeight="regular"
                            dominantBaseline="middle"
                            x={valueBgWidth / 2}
                            y={15}
                            textAnchor="middle"
                        >{"-" + value}</text>
                    </g>
                </g>
            )
        }
    } else {
        let arcStart = axisSideMargin + axisLineWidth / 2 + (value_1 - value_2 - axisStart) * axisDivWidth
        let arcLength = (value_2) * axisDivWidth
        let arcRadius = (arcLength) / 1.8
        let centerToChordLenght = Math.sqrt(Math.pow(arcRadius, 2) - Math.pow(arcLength / 2, 2))
        maxArcHeight = arcRadius - centerToChordLenght + 40
        curves.push(
            <g key={0}>
                <path
                    d={`M${arcStart} 185 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                    stroke="#000"
                    strokeOpacity="0.1"
                    strokeWidth="4.01490021"
                    fill="none"
                    strokeDasharray="6.0312, 8.0415"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                />
                <path
                    d={`M${arcStart} 180 a ${arcRadius} ${arcRadius} 0 0 1 ${arcLength} 0`}
                    stroke="#E30613"
                    strokeWidth="4.01490021"
                    fill="none"
                    strokeDasharray="6.0312, 8.0415"
                    strokeLinejoin="round"
                    strokeLinecap="round"
                />
                {utils.getArrowLayout(arcStart, 185, 40, 4.01490021, "#E30613")}
                <g transform={`translate(${arcStart + arcLength / 2 - valueBgWidth / 2}, ${180 + centerToChordLenght - arcRadius - valueBgHeight * 1.2})`}>
                    <image
                        width={valueBgWidth}
                        height={valueBgHeight}
                        xlinkHref={images.svg['number-line-bg-red']}

                    />
                    <text
                        fill="#fff"
                        fontSize={12}
                        fontWeight="regular"
                        dominantBaseline="middle"
                        x={valueBgWidth / 2}
                        y={15}
                        textAnchor="middle"
                    >{settings.answer_required === 'value_2' ? answer :  "-" + (value_2)}</text>
                </g>
            </g>
        )
    }

    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}

        >
            <g transform={`translate(${(gameContainerWidth - gridBgWidth * scale) / 2}, ${(gameContainerHeight - gridBgHeight * scale - (gridBgHeight - maxArcHeight) * scale) / 2}), scale(${scale})`}>
                {axisValues}
                <image
                    width={lineWidth}
                    height={lineHeight}
                    xlinkHref={images.svg['number-line']}
                    transform={`translate(${0}, ${gridBgHeight - 13})`}
                />
                {curves}

            </g>
        </svg>
    )
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/numberLines.utils.js